import React, { useState } from 'react';
import './PrivacyPolicy.css'; 

const PrivacyPolicy = () => {
  // 🌟 State for Language Toggle ('mn' or 'en')
  const [lang, setLang] = useState('mn');

  // 🌟 Content Dictionary
  const content = {
    mn: {
      title: "Нууцлалын бодлого",
      date: "Сүүлд шинэчлэгдсэн огноо: 2026 оны 3-р сарын 25",
      intro: "\"iParking\" ухаалаг зогсоолын систем (цаашид \"Бид\", \"Апп\" гэх)-ийг сонгон үйлчлүүлж буй танд баярлалаа. Бид таны хувийн мэдээллийн нууцлалыг чандлан хамгаалахыг эрхэм зорилгоо болгон ажилладаг. Энэхүү нууцлалын бодлого нь бид таны мэдээллийг хэрхэн цуглуулж, ашиглаж, хамгаалдаг болохыг тайлбарлах болно.",
      sec1Title: "1. Бидний цуглуулдаг мэдээлэл",
      sec1Intro: "Апп-ын хэвийн үйл ажиллагааг хангахын тулд бид дараах мэдээллүүдийг цуглуулдаг:",
      sec1List1: "Хувийн мэдээлэл: Хэрэглэгчийн нэр, И-мэйл хаяг, Утасны дугаар.",
      sec1List2: "Тээврийн хэрэгслийн мэдээлэл: Автомашины улсын дугаар (Зогсоол руу нэвтрэх болон төлбөр тооцоог үнэн зөв бодоход зориулагдсан).",
      sec1List3: "Төхөөрөмжийн мэдээлэл: Төхөөрөмжийн давтагдашгүй дугаар (Device ID) болон Үйлдлийн системийн хувилбар.",
      sec1List4: "Төхөөрөмжийн хандалт (Permissions):",
      sec1Sub1: "Bluetooth: Зогсоолын хаалттай холбогдож, хаалт нээх үйлдэлд зөвхөн тухайн агшинд ашиглагдана.",
      sec1Sub2: "Notifications (Мэдэгдэл): Зогсоолд орсон, гарсан болон төлбөрийн мэдээллийг цаг тухайд нь хүргэх зорилготой.",
      sec2Title: "2. Мэдээллийг хэрхэн ашиглах вэ?",
      sec2Intro: "Таны мэдээллийг дараах зорилгоор ашиглана:",
      sec2List1: "Хэрэглэгчийн бүртгэл үүсгэх, баталгаажуулах (Apple, Google эсвэл Email ашиглан).",
      sec2List2: "Зогсоолын хаалтыг автоматаар нээх, зогсоолд байршсан хугацааг тооцоолох.",
      sec2List3: "Төлбөр тооцоог үнэн зөв, найдвартай гүйцэтгэх, И-баримт олгох.",
      sec2List4: "Апп-ын үйл ажиллагааг сайжруулах, техникийн алдааг засварлах.",
      sec3Title: "3. Мэдээлэл хуваалцах",
      sec3Intro: "Бид таны хувийн мэдээллийг гуравдагч этгээдэд худалдахгүй, түрээслэхгүй. Гэсэн хэдий ч апп-ын хэвийн ажиллагааг хангахын тулд дараах найдвартай үйлчилгээнүүдтэй мэдээлэл солилцдог:",
      sec3List1: "Google Firebase: Хэрэглэгчийн бүртгэл болон өгөгдлийн сангийн аюулгүй байдлыг хангах.",
      sec3List2: "Төлбөрийн гарцууд: Төлбөр төлөх үед банкны системүүдтэй аюулгүй холбогдох.",
      sec4Title: "4. Мэдээллийн аюулгүй байдал",
      sec4Text: "Бид таны мэдээллийг олон улсын стандартад нийцсэн шифрлэлт (Encryption) ашиглан хадгалдаг. Мөн нэг хэрэглэгчийн эрхээр олон төхөөрөмжөөс зэрэг нэвтрэхийг хязгаарлах зэрэг аюулгүй байдлын нэмэлт арга хэмжээнүүдийг авч хэрэгжүүлдэг.",
      sec5Title: "5. Хэрэглэгчийн эрх болон Мэдээлэл устгах",
      sec5Text: "Та өөрийн хувийн мэдээллийг харах, өөрчлөх, мөн системээс бүрмөсөн устгуулах бүрэн эрхтэй.",
      sec5BoxTitle: "Бүртгэл устгах хүсэлт гаргах заавар:",
      sec5Box1: "Апп-ын \"Тохиргоо\" (Settings) цэс рүү орно.",
      sec5Box2: "\"Бүртгэл устгах\" (Delete Account) товчийг дарна.",
      sec5Box3: "Эсвэл доорх И-мэйл хаягаар бидэнд хандаж бүртгэлээ устгуулах хүсэлт илгээх боломжтой. Бүртгэл устгагдсанаар таны бүх өгөгдөл манай сангаас устгах болно.",
      sec6Title: "6. Холбоо барих",
      sec6Text: "Энэхүү нууцлалын бодлоготой холбоотой асууж тодруулах зүйл гарвал дараах сувгаар бидэнтэй холбогдоно уу:",
      address: "Хаяг: Улаанбаатар хот, Монгол улс, ХУД 4-р хороо"
    },
    en: {
      title: "Privacy Policy",
      date: "Last updated: March 25, 2026",
      intro: "Thank you for choosing the \"iParking\" smart parking system (hereinafter referred to as \"We\" or \"App\"). We are committed to protecting your privacy. This privacy policy explains how we collect, use, and safeguard your personal information.",
      sec1Title: "1. Information We Collect",
      sec1Intro: "To ensure the proper functioning of the app, we collect the following information:",
      sec1List1: "Personal Information: Name, Email address, and Phone number.",
      sec1List2: "Vehicle Information: License plate number (Used for access to the parking lot and accurate billing).",
      sec1List3: "Device Information: Unique Device ID and Operating System version.",
      sec1List4: "Device Permissions:",
      sec1Sub1: "Bluetooth: Used strictly at the moment of connecting to and automatically opening the smart parking barrier.",
      sec1Sub2: "Notifications: Used to deliver timely updates regarding parking entry/exit and billing statements.",
      sec2Title: "2. How We Use Your Information",
      sec2Intro: "Your information is used for the following purposes:",
      sec2List1: "To create and verify user accounts (via Apple, Google, or Email).",
      sec2List2: "To automatically open parking barriers and calculate parking duration.",
      sec2List3: "To process payments securely and issue e-receipts.",
      sec2List4: "To improve app performance and fix technical issues.",
      sec3Title: "3. Information Sharing",
      sec3Intro: "We do not sell or rent your personal information to third parties. However, to ensure app functionality, we share data with the following reliable services:",
      sec3List1: "Google Firebase: For secure user authentication and database management.",
      sec3List2: "Payment Gateways: For secure banking connections during transactions.",
      sec4Title: "4. Data Security",
      sec4Text: "We store your data using international standard encryption. We also implement additional security measures, such as restricting simultaneous logins from multiple devices using the same account.",
      sec5Title: "5. User Rights and Account Deletion",
      sec5Text: "You have the full right to view, modify, or permanently delete your personal information from our system.",
      sec5BoxTitle: "How to request account deletion:",
      sec5Box1: "Go to the \"Settings\" menu in the app.",
      sec5Box2: "Click the \"Delete Account\" button.",
      sec5Box3: "Alternatively, you can contact us via the email below to request deletion. Upon deletion, all your data will be permanently removed from our database.",
      sec6Title: "6. Contact Us",
      sec6Text: "If you have any questions regarding this privacy policy, please contact us:",
      address: "Address: Ulaanbaatar, Mongolia, HUD 4th khoroo"
    }
  };

  const t = content[lang]; // T гэдэг нь одоо сонгогдсон хэлний мэдээлэл

  return (
    <div className="privacy-container">
      <div className="privacy-card">
        
        {/* 🌟 Хэл солих товч болон Гарчиг */}
        <div className="header-top">
          <div>
            <h1 className="privacy-title">{t.title}</h1>
            <p className="privacy-date">{t.date}</p>
          </div>
          
          <div className="lang-toggle">
            <button 
              className={`lang-btn ${lang === 'mn' ? 'active' : ''}`}
              onClick={() => setLang('mn')}
            >
              Монгол
            </button>
            <button 
              className={`lang-btn ${lang === 'en' ? 'active' : ''}`}
              onClick={() => setLang('en')}
            >
              English
            </button>
          </div>
        </div>

        <div className="privacy-header"></div>

        {/* 🌟 Агуулга */}
        <div className="privacy-content">
          
          <section>
            <p>{t.intro}</p>
          </section>

          <section>
            <h2>{t.sec1Title}</h2>
            <p>{t.sec1Intro}</p>
            <ul>
              <li><strong>{t.sec1List1.split(':')[0]}:</strong> {t.sec1List1.split(':')[1]}</li>
              <li><strong>{t.sec1List2.split(':')[0]}:</strong> {t.sec1List2.split(':')[1]}</li>
              <li><strong>{t.sec1List3.split(':')[0]}:</strong> {t.sec1List3.split(':')[1]}</li>
              <li><strong>{t.sec1List4}</strong>
                <ul>
                  <li><strong>Bluetooth:</strong> {t.sec1Sub1.split(':')[1]}</li>
                  <li><strong>Notifications:</strong> {t.sec1Sub2.split(':')[1]}</li>
                </ul>
              </li>
            </ul>
          </section>

          <section>
            <h2>{t.sec2Title}</h2>
            <p>{t.sec2Intro}</p>
            <ul>
              <li>{t.sec2List1}</li>
              <li>{t.sec2List2}</li>
              <li>{t.sec2List3}</li>
              <li>{t.sec2List4}</li>
            </ul>
          </section>

          <section>
            <h2>{t.sec3Title}</h2>
            <p>{t.sec3Intro}</p>
            <ul>
              <li><strong>{t.sec3List1.split(':')[0]}:</strong> {t.sec3List1.split(':')[1]}</li>
              <li><strong>{t.sec3List2.split(':')[0]}:</strong> {t.sec3List2.split(':')[1]}</li>
            </ul>
          </section>

          <section>
            <h2>{t.sec4Title}</h2>
            <p>{t.sec4Text}</p>
          </section>

          <section>
            <h2>{t.sec5Title}</h2>
            <p>{t.sec5Text}</p>
            <div className="privacy-box">
              <p className="privacy-box-title">{t.sec5BoxTitle}</p>
              <ol>
                <li>{t.sec5Box1}</li>
                <li>{t.sec5Box2}</li>
                <li>{t.sec5Box3}</li>
              </ol>
            </div>
          </section>

          <section>
            <h2>{t.sec6Title}</h2>
            <p>{t.sec6Text}</p>
            <div className="contact-info">
              <span>Email: <a href="mailto:iparkingiparking@gmail.com" className="contact-link">iparkingiparking@gmail.com</a></span>
              <span>Phone: +976 80551166</span>
              <span>{t.address}</span>
            </div>
          </section>

        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;